<!--
  Notification empty list state component

  <NotificationEmptyState />
-->
<script setup lang="ts">
/* COMPONENTS */
import { useCssBreakpoints } from '@af-lib/vue-ui';

/* CONFIG */
import { t } from '@/config/i18n';

import Text from '../text/Text.vue';

/* UTILS */
const { tabletAndUp } = useCssBreakpoints();
</script>

<template>
  <v-sheet
    :width="tabletAndUp ? 460 : undefined"
    height="230"
    class="d-flex flex-column align-center justify-center notification-empty-container"
  >
    <div class="d-flex align-center justify-center notification-empty-circle">
      <v-icon icon="fat fa-bell-on" color="notificationEmptyStateBell"></v-icon>
    </div>
    <Text type="body3" fontColor="font-textSecondary" class="notification-empty-text text-center">
      {{ t('notifications.empty_state') }}
    </Text>
  </v-sheet>
</template>

<style scoped lang="scss">
.notification-empty-container {
  gap: 16px;
}

.notification-empty-circle {
  width: 56px;
  height: 56px;
  border: 1px solid rgb(var(--v-theme-notificationEmptyStateBell));
  border-radius: 50%;
}

.notification-empty-text {
  width: 230px;
}
</style>
